import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {ActiveLocales, ListTranslationsResponse, Translation} from "../http/protocol";


export class TranslationsService  extends AbstractAdminEntityService<Translation, ListTranslationsResponse>  {

    constructor(http : HttpService) {
        super("/translations", http)
    }

    getLocales() : Promise<ActiveLocales> {
        return this.http.get(this.entityPath + "/locales");
    }

}